export default "__VITE_ASSET__9fb080c5__"